export class AudioEmbed {
    #player;
    #element;

    get player() { return this.#player; }
    get element() { return this.#element; }

    constructor(player) {
        this.#player = player;
        this.#element = <div class={`aembed aembed-${player.type}`}>{player}</div>;
    }
}

export class AudioEmbedPlayer {
    #element;

    get element() { return this.#element; }
    get type() { return 'external'; }

    constructor(metadata) {
        this.#element = <audio src={metadata.url} autoplay={true} controls={true} />;
    }
}

export class AudioEmbedPlaceholder {
    #element;

    get element() { return this.#element; }

    constructor(metadata, playerType) {
        if(typeof playerType !== 'function')
            throw new Error('playerType must be a function');

        let title = <h1 class="aembedph-info-title" />;
        let album = <p class="aembedph-info-album" />;
        if(metadata.media !== undefined && metadata.media.tags !== undefined) {
            const tags = metadata.media.tags;

            if(tags.title !== undefined) {
                if(tags.artist !== undefined) {
                    title.appendChild(<span class="aembedph-info-title-artist">{tags.artist}</span>);
                    title.appendChild(document.createTextNode(' - '));
                }

                title.appendChild(<span class="aembedph-info-title-title">{tags.title}</span>);
            } else {
                title.appendChild(<span class="aembedph-info-title-title">{metadata.title}</span>);
            }

            if(tags.album !== undefined && tags.album !== tags.title)
                album.textContent = tags.album;
        }

        this.#element = <div class="aembedph aembedph-external" style={{ '--aembedph-colour': metadata.color }} title={metadata.title}>
            <div class="aembedph-bg">
                <img src={metadata.image} alt="" onerror={function() { this.classList.add('aembedph-bg-none') }} />
            </div>
            <div class="aembedph-fg">
                <div class="aembedph-info">
                    <div class="aembedph-info-cover">
                        <img src={metadata.image} alt="" onerror={function() { this.classList.add('aembedph-info-cover-none') }} />
                    </div>
                    <div class="aembedph-info-body">
                        {title}
                        {album}
                        <div class="aembedph-info-site">{metadata.site_name}</div>
                    </div>
                </div>
                <div class="aembedph-play" onclick={ev => {
                    if(ev.target instanceof HTMLAnchorElement)
                        return;

                    const embed = new AudioEmbed(new playerType(metadata));
                    this.#element.replaceWith(embed.element);
                }}>
                    <div class="aembedph-play-internal">
                        <i class="fa-solid fa-play fa-3x" />
                    </div>
                    <div class="aembedph-play-external">
                        <a class="aembedph-play-external-link" href={metadata.url} target="_blank" rel="noopener">
                            {`or listen on ${metadata.site_name}?`}
                        </a>
                    </div>
                </div>
            </div>
        </div>;
    }
}
